/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForJiraServiceManagementProject extends models.ServiceAccountNativeDetailsBaseForJiraServiceManagement {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForJiraServiceManagementProject");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForJiraServiceManagementProject.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForJiraServiceManagementProject>): ServiceAccountNativeDetailsForJiraServiceManagementProject {
        let obj = Object.assign(new ServiceAccountNativeDetailsForJiraServiceManagementProject(), model);
        ServiceAccountNativeDetailsForJiraServiceManagementProject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForJiraServiceManagementProject>): ServiceAccountNativeDetailsForJiraServiceManagementProject {
        if (!model) return null;
        return ServiceAccountNativeDetailsForJiraServiceManagementProject.newInstance(<ServiceAccountNativeDetailsForJiraServiceManagementProject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForJiraServiceManagementProject) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForJiraServiceManagementProject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForJiraServiceManagementProject): boolean {
        if (models.ServiceAccountNativeDetailsBaseForJiraServiceManagement.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForJiraServiceManagementProject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.product_activation) {
            for (let val of this.product_activation) {
                models.IntegratedToolProductActivation.fixupPrototype(val);
            }
        }
    }

    product_activation: Array<models.IntegratedToolProductActivation>;

    /**
     * Project Id. This is a required field.
     */
    project_id: string;

    /**
     * Project Name. This is a required field.
     */
    project_name: string;

    /**
     * Project Key. This is a required field.
     */
    project_key: string;

}
